import { useEffect } from "react";
import { useLocation } from 'react-router-dom';


const useScrollToAnchor = () => {
    const location = useLocation();

    const scrollToAnchor = (hash) => {
        let anchorElement = document.getElementById(hash.substring(1));
        if (anchorElement) {
            anchorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            setTimeout(() => {
                anchorElement = document.getElementById(hash.substring(1));
                anchorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 1000);
        }
    };

    useEffect(() => {
        if (location?.hash) {
            scrollToAnchor(location?.hash);
        }
    }, []);
};

export default useScrollToAnchor;